import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loading from './common/Loading';

const PrivateRoute = ({ children, adminOnly = false, requiredRoute, requiredPermission }) => {
  const { isAuthenticated, isAdmin, loading, hasPagePermission } = useAuth();

  if (loading) {
    return <Loading fullScreen text="Loading..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Permission-based check: if requiredRoute is specified, check permissions
  if (requiredRoute) {
    const permission = requiredPermission || 'can_list';
    const hasAccess = hasPagePermission(requiredRoute, permission) || 
                      (permission === 'can_list' && hasPagePermission(requiredRoute, 'can_view'));
    if (!hasAccess) {
      return <Navigate to="/dashboard" replace />;
    }
    return children;
  }

  // Legacy adminOnly check
  if (adminOnly && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;
